export enum ApiCodeEnum {
  UnknownError = -1,
  Success = 0, // 成功
  Failure = 7 // 失败
}

export enum BusApiCodeEnum {
  SecretError = 1, // 加密签名错误
  LoginFailure = 1001, // 登录失败
  // t('api.code.1002')
  emailRegistered = 1002, // 郵箱註冊
  LoginPWDFailure = 1003, // 登陆密码错误
  UnregistrableCountry = 1004, // 当前国家不支持注册
  UnexpectedGender = 1005, // 当前性别不存在，不支持注册
  ChineseNameOnly = 1006, // 请使用中文名字
  CFPError = 1007, // 中文全名或者CFP号码不匹配
  EnglishOnly = 1008, // 只能输入英文字母
  CPFError = 1009, // 错误的CPF号码
  UnexpectedParams = 1010, // 参数类型错误
  UnexpectedPhone = 1011, // 错误的手机号码
  HttpParserError = 1012, // http解析错误
  // t('api.code.1013')
  ExistedPhone = 1013, // 手机号已经注册
  UnexpectedBirthday = 1014, // 生日格式错误
  // t('api.code.1015')
  UsernameOrPasswordError = 1015, // 用户名或者密码错误
  // t('api.code.1016')
  CaptchaError = 1016, // 验证码错误
  // t('api.code.1017')
  ExistedUsername = 1017, // 用户名已存在
  NoEmptyString = 1018, // xxxx 字段不能为空
  StringFormError = 1019, // xxxx 字段验证不通过，一般用于正则校验某个字段规则
  StringLenError = 1020, // xxxx 字段长度或值不符合范围
  StringNotset = 1021, // xxxx 字段没有设置
  ExpiredToken = 1022, // Token过期
  BannedToken = 1023, // Token已加入黑名单
  BannedUser = 1024, // 登录失败 - 黑名單
  IPNotAllowed = 1025, // IP禁止登录
  GoogleAuthNotBind = 1026, // 未绑定谷歌验证码
  GoogleAuthCaptchaError = 1027, // 谷歌验证码错误
  GoogleAuthSecretError = 1028, // 谷歌验证码密钥错误
  No2FA = 1029, // 未开启二次验证
  GoogleAuthAlreadyBind = 1030, // 已经绑定过谷歌验证码
  RestrictLogin = 1031, // 登入失敗-帳號已被限制登入
  UsernameNotExist = 1032, // 用户名不存在
  NotMatchUsernameAndEmail = 1033, // 用户名和邮箱不匹配
  NotMatchBirthdayAndEmail = 1034, // 生日和邮箱不匹配
  EmailNotExist = 1035, // email不存在
  EmailCaptchaError = 1036, // 邮件验证码错误
  PasswordNotMatch = 1037, // 两次密码不一致
  UnderAge18 = 1038, // 未满18周岁
  CPFexisted = 1039, // CFP号码已经存在
  NotMatchValue = 1040,	// not match value	无匹配值，一般用于状态码匹配不上
  UserOffline = 1041,	// user is offline	会员已离线
  NotAllowedTelAreaCode = 1042, // tel area code not register	手机区号不支持注册
  NotRecord = 1043,	// record not existed code	记录不存在(用指定参数查询数据，没有记录)
  NotAllowedCurrency = 1044, //	currency not existed code	币别不存在
  IllegalRequest = 1045,	// illegal request	不合法請求(無對應用戶資料一率回傳此錯誤)
  InsufficientBalance = 1046, //	insufficient balance	帳戶餘額不足(不夠作業需求)

  UnLogin = 1052, // 未登录
  ExpiredPassword = 1068, // 密码过期过期
  NoVerfiedKYC = 1073, // kyc验证未通过
  VerifiedKYC = 1076, // kyc已经验证通过

  // mmm
  CurrencyBennSetted = 1101, //	The betting currency has already been set and cannot be set again.	用戶投注幣別已設定過，無法重覆設定
  CurrencyNotInRange = 1102, //	The set currency code does not match the range	欲設定的幣別代碼不符合範圍
  WithdrawPasswrodError = 1103, //	Withdrawal password is incorrect	提款密碼有誤
  BankAccountOverLimit = 1104, //	The binding limit has been exceeded	已超過綁定上限數量  (一人限定綁20張銀行帳戶)
  FavoritesOverLimit = 1105, //	Favorites used settings have exceeded the set limit	已超過設定最愛上限數量  (一人常用帳戶最多可設定5組)
  BankAccountExisted = 1106, //	bank account number  already exists	Bank account number 已存在
  PIXExisted = 1107, //	PIX key already exists	PIX key 已存在

  // 存款專用
  NoDepositPermission = 1121, //	execute job without permission	管端設定為黑名單，無法執行該項作業
  NoVerifiedEmail = 1122, // email not verified	email未通過驗證，無法執行該項作業
  VendorPaymentError = 1123, // payment vendor error	第三方支付通道處理錯誤
  AmountOverLimit = 1124,	// amount exceeds the limit	金額超出限額
  HasWithdrawOnGoing = 1125, // have a withdrawal under review	該用戶尚有一筆提款尚在審核中
  OverRequest = 1126, //	job requests exceeds the limit	作業請求超過限制次數
  TouroverNotMet = 1127, // still turnover not met	流水不足
  CurrencyNotMatch = 1128, // the operating currency does not match the current use	操作貨幣與使用貨幣不符
  CasinoLimits = 1200, // casino后台限额
  DepostLimits = 1201, // 充值自我限额
  // CPF專用
  DiedCPF = 1301, //	去世/业务其他问题
  UnderageCPF = 1302, // 未成年
  SystemErrorCPF = 1303, //系统报错

  // payment
  PaymentApiFailure = 2001, // 支付通道-api呼叫失败
  PaymentParameterInvalid = 2002, // 支付通道-参数无效
  PaymentSignatureInvalid = 2003, // 支付通道-签名错误
  PaymentMerchantNotExisted = 2004, // 支付通道-商户不存在
  PaymentMerchantDisabled = 2005, // 支付通道-商户被禁用
  PaymentOrderRepeat = 2006, // 支付通道-订单重复
  PaymentDepositOrderNotExisted = 2007, // 支付通道-代收订单不存在
  PaymentWithdrawalOrderNotExisted = 2008, // 支付通道-代付订单不存在
  PaymentChannelNotExisted = 2009, // 支付通道-通道不存在
  PaymentChannelStopUse = 2010, // 支付通道-暂停使用
  PaymentThirdChannelStopUse = 2011, // 支付通道-三方通道停用

  //sbm 投注 專用
  InsufficientAmount = 4001, // 金額不足,無法投注
  BetDataNotCorrect = 4002, // 下注單據資訊不正確
  // bonus 投注专用
  InsufficientBonus = 4008, // Bonus 投注金额不足
  OddLowsBonus = 4009, // 不满足 Bonus 投注最低赔率要求
  JackpotsExpired = 7002, // 乐透期号已经过期
  ServerNeedKYC = 1077, //服务端要求去kyc认证
  PhoneUsed = 1092, //手机号已被使用
  depositWaitTimeErr = 1133 //存款请求超过最小频率
}

export enum BetBusApiCodeEnum {
  AccountHasBeenFrozen = 1001,
  LoginPasswordError = 1003,
  LoginFailBlack = 1031,
  ExistedUsername = 1017,
  IncorrectUsernameOrPassword = 1049,
  PasswordFormatError = 1129,
  DateFormatError = 3002, // 日期格式错误
  ExistedIP = 3003, // IP已存在
  ExistedUser = 3004, // 用户已存在
  PasswordError = 3005, // 密码错误
  NonUser = 3006, // 用户不存在
  DeniedLogin = 3007, // 拒绝该用户登录
  MgtCaptchaError = 3008, // 验证码错误
  TokenError = 3009, // 获取token失败
  LoginError = 3010, // 设置登录状态失败
  BanTokenError = 3011, // jwt加入黑名单失败
  OldPasswordError = 3012, // 原密码错误
  NoRole = 3013, // 用户没有此权限
  GoogleCaptchaError = 3014, // 谷歌验证码错误
  NonParameter = 3015, // 参数不存在或关闭状态
  ExistedType = 3016, // 这个type已存在，不能创建
  NoPermission = 3017, // 权限不足
  DeniedIP = 3018, // ip拒绝访问
  UnauthAccess = 3019, // 未登录或非法访问
  InvaildToken = 3020, // 您的帐户在异地登录或令牌无效
  // TokenExpired = 3021, // token过期
  ExistedName = 3022, // name已经存在，请修改name值
  Undeletable = 3023, // 这个菜单有子菜单无法删除
  AuthorityNNameExisted = 5000,
  ForceQuit = 50001, // 这个菜单有子菜单无法删除
  CurrentAccountNotMatch = 5001,
  DuplicatedPassword = 5003,
  PasswordExpiredCode = 5004, // 密码过期码
  NotLoggedInOrIllegalAccess = 5012,
  TheTokenHasExpired = 5015
}
